import {ref} from 'vue';
import {getCookie} from '@/shared/lib/utils/cookie';

/** Есть кука сессии — значит, пользователь вошёл; живая ли сессия, покажет первый запрос */
export const hasSessionCookie = (): boolean => Boolean(getCookie('GATEWAY') || getCookie('HASH_SESSION'));

/**
 * Признак авторизации живёт отдельным синглтоном, а не в userStore: его читает query-слой,
 * который сам используется внутри стора — вызов useUserStore() оттуда увёл бы Pinia
 * в рекурсивную инициализацию.
 *
 * Начальное значение берётся из куки: гард роутера смотрит на него уже на первом переходе,
 * до загрузки профиля. Протухшую сессию сбросит обработчик 401 через logout().
 */
export const isAuth = ref<boolean>(hasSessionCookie());
